// ─────────────────────────────────────────────────────────────
// GlassIcons — reactbits 원본을 NAS 폴더용으로 확장 (v7.355)
//
// 원본 구조는 그대로다:
//   icon-btn__back   뒤에 깔리는 색 판 (기울어져 있다가 호버 시 펴진다)
//   icon-btn__front  그 위의 유리판
//   icon-btn__icon   유리판 안의 내용  ← 여기에 아이콘 대신 무엇이든 넣을 수 있다
//   icon-btn__label  아래 이름표
//
// 사용자 질문("아이콘 대신 이미지를 넣을 수 있나")에 대한 답:
//   {item.icon} 은 JSX 노드를 그대로 렌더하는 자리라 <img> 든 <svg> 든 들어간다.
//   ⚠ 다만 이미지 파일은 이 프로젝트에서 쓰기 나쁘다 — public/ 이 NAS 에만 있어서
//     파일을 여기서 못 넣고, PNG 는 다크 모드에서 색이 안 따라온다.
//     → 폴더는 SVG(FolderGlyph)로 그려 넣었다.
//
// 원본에서 더한 것:
//   ・ subtitle  이름 아래 한 줄 (사양 요약)
//   ・ onClick   원본은 button 이면서 클릭 핸들러가 없었다
//   ・ open      호버 시 폴더 뚜껑이 열리도록 CSS 에서 제어
//
// ⚠ CSS import 를 절대 빼먹지 말 것. v7.354 에서 이걸 빠뜨려 폴더가 새까맣게 나왔다
//   (fill 이 기본값 검정이 되고, 숨겨야 할 사양이 전부 펼쳐졌다).
// ─────────────────────────────────────────────────────────────
import React from 'react';
import './GlassIcons.css';

const gradientMapping = {
  blue: 'linear-gradient(hsl(223, 90%, 50%), hsl(208, 90%, 50%))',
  purple: 'linear-gradient(hsl(283, 90%, 50%), hsl(268, 90%, 50%))',
  red: 'linear-gradient(hsl(3, 90%, 50%), hsl(348, 90%, 50%))',
  indigo: 'linear-gradient(hsl(253, 90%, 50%), hsl(238, 90%, 50%))',
  orange: 'linear-gradient(hsl(43, 90%, 50%), hsl(28, 90%, 50%))',
  green: 'linear-gradient(hsl(123, 90%, 40%), hsl(108, 90%, 40%))',
  amber: 'linear-gradient(hsl(45, 92%, 55%), hsl(33, 92%, 48%))',
};

// 윈도우 폴더 글리프.
//   ⚠ 앞판 회전축은 왼쪽 아래다. 중앙을 축으로 돌리면 앞판이 위로 올라가
//     안의 종이를 덮어버린다 (v7.354 시제품에서 실제로 그랬다).
export function FolderGlyph({ sheets = 2 }) {
  const n = Math.max(1, Math.min(3, sheets));
  return (
    <svg viewBox="0 0 132 132" className="fdg" aria-hidden="true">
      <path className="fdg__back"
        d="M8 30 h34 l9 11 h55 a7 7 0 0 1 7 7 v56 a7 7 0 0 1 -7 7 h-98 a7 7 0 0 1 -7 -7 v-67 a7 7 0 0 1 7 -7 z" />
      {Array.from({ length: n }, (_, i) => {
        const x = 25 + i * 9 - (n - 1) * 4.5;
        return (
          <g key={i} className="fdg__sheet" style={{ '--i': i }}>
            <rect x={x} y={52} width={76} height={58} rx={3} className="fdg__paper" />
            <rect x={x + 10} y={63} width={44} height={4.5} rx={2.2} className="fdg__line" />
            <rect x={x + 10} y={74} width={32} height={4.5} rx={2.2} className="fdg__line fdg__line--2" />
          </g>
        );
      })}
      <path className="fdg__front"
        d="M8 62 h110 a7 7 0 0 1 7 7 v42 a7 7 0 0 1 -7 7 h-110 a7 7 0 0 1 -7 -7 v-42 a7 7 0 0 1 7 -7 z" />
    </svg>
  );
}

const GlassIcons = ({ items, className }) => {
  const getBackgroundStyle = (color) => {
    if (gradientMapping[color]) return { background: gradientMapping[color] };
    return { background: color };
  };

  return (
    <div className={`icon-btns ${className || ''}`}>
      {items.map((item, index) => (
        <button
          key={item.key ?? index}
          className={`icon-btn ${item.customClass || ''}`}
          aria-label={item.label}
          title={item.title || item.label}
          type="button"
          onClick={item.onClick}>
          <span className="icon-btn__back" style={getBackgroundStyle(item.color)}></span>
          <span className="icon-btn__front">
            <span className="icon-btn__icon" aria-hidden="true">
              {item.icon}
            </span>
          </span>
          <span className="icon-btn__label">{item.label}</span>
          {item.subtitle && <span className="icon-btn__sub">{item.subtitle}</span>}
        </button>
      ))}
    </div>
  );
};

export default GlassIcons;
